import { useSelector } from 'react-redux';

import {
  AppState,
  PermissionStatus,
  SettingsRecommendationsReducerState,
} from '../../../store/interfaces';

export function usePermissionPages() {
  const permissions = useSelector((app: AppState) => app.settingsRecommendations.permissions);
  const isReviewApp = useSelector((app: AppState) => app.app.isReviewApp);

  function shouldShow(permission: keyof SettingsRecommendationsReducerState['permissions']) {
    if (
      permissions[permission] === PermissionStatus.Undefined ||
      permissions[permission] === undefined
    ) {
      return false;
    }
    return permissions[permission] !== PermissionStatus.Always;
  }

  const showLocationPage = shouldShow('location');
  const showBatteryPage = shouldShow('battery');
  const showNotificationPage = shouldShow('notification');
  const showGpsPage = shouldShow('gps') && !isReviewApp;

  return {
    showLocationPage,
    showBatteryPage,
    showNotificationPage,
    showGpsPage,
  };
}
